import { useTheme } from '../../../../../../hooks/useTheme';
import styles from '../Fetch.module.css';
import { FetchOfferBar } from './FetchOfferBar';
import { FetchOfferPanel } from './FetchOfferPanel';
import { FetchPetForm } from './FetchPetForm';
import { FetchPetScreenMobile } from './FetchPetScreenMobile';
import type { FetchPetFormValues } from '../types';

interface FetchPetScreenProps {
  onSubmit: (values: FetchPetFormValues) => void;
  loading?: boolean;
  initialEmail?: string;
  initialZip?: string;
  initialValues?: FetchPetFormValues | null;
  isMobile?: boolean;
}

export function FetchPetScreen({
  onSubmit,
  loading,
  initialEmail,
  initialZip,
  initialValues,
  isMobile,
}: FetchPetScreenProps) {
  const theme = useTheme();

  if (isMobile) {
    return (
      <FetchPetScreenMobile
        onSubmit={onSubmit}
        loading={loading}
        initialEmail={initialEmail}
        initialZip={initialZip}
        initialValues={initialValues}
      />
    );
  }

  const rootClass = styles.petScreen;

  return (
    <div
      className={rootClass}
      style={{ fontFamily: theme.bodytextDefaultNone?.fontFamily }}
    >
      {!isMobile && <FetchOfferBar />}
      <div className={styles.petBody}>
        <FetchOfferPanel isMobile={isMobile} />
        <FetchPetForm
          onSubmit={onSubmit}
          loading={loading}
          initialEmail={initialEmail}
          initialZip={initialZip}
          initialValues={initialValues}
          isMobile={isMobile}
        />
      </div>
    </div>
  );
}
